import React, { useEffect, useState } from "react";
import { GetAssignedFacilitiesList } from "adminApi/AssignRoomFacilitiesApi/AssignRoomFacilities";

const CheckboxGroup = ({ values, setValues, facilityOptions, field }) => {
    const [facilities, setFacilities] = useState([]);
    const [selectedFacilities, setSelectedFacilities] = useState([]);

    useEffect(() => {
        const loadFacilities = async () => {
            setFacilities(facilityOptions || []);

            if (values.room_type) {
                try {
                    const assigned = await GetAssignedFacilitiesList(values.room_type);
                    const assignedData = assigned?.data?.data || [];
                    const assignedIds = assignedData.map(item => item.facility_id);

                    setSelectedFacilities(assignedIds);
                    setValues(prev => ({ ...prev, facility_id: assignedIds }));
                } catch (error) {
                    console.error("Error fetching assigned facilities:", error);
                }
            } else {
                setSelectedFacilities([]);
                setValues(prev => ({ ...prev, facility_id: [] }));
            }
        };

        loadFacilities();
    }, [values.room_type, facilityOptions, setValues]);

    /* ---------- Individual toggle ---------- */
    const toggleFacility = (id) => {
        const updated = selectedFacilities.includes(id)
            ? selectedFacilities.filter(fid => fid !== id)
            : [...selectedFacilities, id];

        setSelectedFacilities(updated);
        setValues(prev => ({ ...prev, facility_id: updated }));
    };

    /* ---------- Select All toggle ---------- */
    const toggleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = facilities.map(f => f.id);
            setSelectedFacilities(allIds);
            setValues(prev => ({ ...prev, facility_id: allIds }));
        } else {
            setSelectedFacilities([]);
            setValues(prev => ({ ...prev, facility_id: [] }));
        }
    };

    /* ---------- Select All checked state ---------- */
    const isAllSelected =
        facilities.length > 0 &&
        selectedFacilities.length === facilities.length;

    return (
        <div className={field.fieldSize || "col-12"}>
            <div className="row g-3  p-3  rounded-3 mt-2" style={{ border: "0.5px dashed var(--primary-color)" }}>

                {/* Select All */}
                <div className="col-12 d-flex align-items-center">
                    {field.label && (
                        <label className="form-label text-muted m-0 me-2">
                            {field.label}
                        </label>
                    )}
                    {field.required && <span className="text-danger me-2">*</span>}
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={isAllSelected}
                        onChange={toggleSelectAll}
                    />
                    {/* <label htmlFor="selectAll" className="ms-2 fw-medium">
                        Select All
                    </label> */}
                </div>

                {/* Facility List */}
                {facilities.map(facility => (
                    <div
                        key={facility.id}
                        className="col-md-4 col-lg-3 col-xxl-2 col-sm-6 col-12"
                    >
                        <div className="form-check p-3 border rounded-3 shadow-sm h-100 d-flex align-items-center">
                            <input
                                id={`facility-${facility.id}`}
                                type="checkbox"
                                className="form-check-input me-3"
                                checked={selectedFacilities.includes(facility.id)}
                                onChange={() => toggleFacility(facility.id)}
                            />
                            <label
                                htmlFor={`facility-${facility.id}`}
                                className="form-check-label mb-0 fw-medium"
                            >
                                {facility.name}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CheckboxGroup;
